// extracted by mini-css-extract-plugin
module.exports = {"Loader":"managerDelivery_Loader__MVRD1","Wrapper":"managerDelivery_Wrapper__mf98I"};